import type { MouseEvent } from 'react'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { AlignCenterItem } from '../../../components/common'
import { Text } from '../../../components/text'

import { ReactComponent as CheckGrayIcon } from '../../../assets/ico/common/check/check_default_gray_line.svg'
import { ReactComponent as CheckBlueIcon } from '../../../assets/ico/common/check/check_checked_blue_line.svg'

interface TermCheckboxProps {
  approved: boolean
  name: string
  toggle: () => void
  required?: boolean
  contents?: components['schemas']['MarkdownContent'][]
  showDetail?: (e: MouseEvent<HTMLSpanElement>) => void
}

export function TermCheckbox({ approved, name, required, contents, toggle, showDetail }: TermCheckboxProps) {
  return (
    <TermItem onClick={toggle}>
      <AlignCenterItem>
        {approved ? <CheckBlueIcon /> : <CheckGrayIcon />}
        <Text size={14} color="text_secondary">
          {typeof required === 'boolean' ? `(${required ? '필수' : '선택'}) ` : null}
          {name}
        </Text>
      </AlignCenterItem>
      {contents && contents?.length > 0 ? (
        <Text size={12} color="text_secondary" style={{ flexShrink: 0 }} onClick={showDetail}>
          보기
        </Text>
      ) : null}
    </TermItem>
  )
}

const TermItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  list-style: none;
  > ${AlignCenterItem} {
    gap: 8px;
    > svg {
      flex-shrink: 0;
    }
  }
  > span {
    text-decoration: underline;
  }
`
